import PropTypes from 'prop-types';
import React, {useCallback, useContext, useMemo, useState} from 'react';

import {RESPONSE_STATUSES} from '@/src/app/constants/api';
import useCourseDetailsActions from '@/src/app/store/courseDetails/useCourseDetailsActions';
import useReviewsWidget from '@/src/app/store/reviewsWidget/useReviewsWidget';
import getRootServerUrl from '@/src/app/utils/getRootServerUrl';

import PopupContext from '../../popup/utils/PopupContext';
import WriteReviewPopup from '../../reviewsWidget/components/WriteReviewPopup';
import sendNewReview from '../../reviewsWidget/utils/sendNewReview';
import FinishCoursePopUpCertificate from '../components/FinishCoursePopUpCertificate';

const MODAL_PAGES = {
  REVIEW: 'review',
  CERTIFICATE: 'certificate',
};

const FinishCoursePopUp = ({certificateId}) => {
  const [modalPageType, setModalPageType] = useState(MODAL_PAGES.CERTIFICATE);
  const {closePopup} = useContext(PopupContext);

  const {addCourseReview} = useReviewsWidget();
  const {course, reviews, setWritingReviewNotAllowed} =
    useCourseDetailsActions();

  const isWritingReviewAllowed = useMemo(
    () => course.isWritingReviewAllowed && !course.isHasComment,
    [course.isWritingReviewAllowed, course.isHasComment]
  );

  const handleAddNewReviewClick = useCallback(
    async (values) => {
      const {status, responseBody} = await sendNewReview(
        course.id,
        values.rating,
        values.comment
      );

      if (status === RESPONSE_STATUSES.SUCCESS) {
        setWritingReviewNotAllowed();
        closePopup();
        addCourseReview(responseBody);
      }
    },
    [course.courseId, reviews]
  );

  const handleConfirmGetCertificateClick = useCallback(() => {
    if (isWritingReviewAllowed) {
      setModalPageType(MODAL_PAGES.REVIEW);
    } else {
      closePopup();
    }
  }, [isWritingReviewAllowed]);

  return (
    <div>
      {modalPageType === MODAL_PAGES.REVIEW && (
        <WriteReviewPopup onAddNewReviewClick={handleAddNewReviewClick} />
      )}
      {modalPageType === MODAL_PAGES.CERTIFICATE && (
        <FinishCoursePopUpCertificate
          onConfirmClick={handleConfirmGetCertificateClick}
          onCancelClick={closePopup}
          certificate={`${getRootServerUrl()}/api/v1/certificate-pdf/${certificateId}.pdf`}
        />
      )}
    </div>
  );
};

export default FinishCoursePopUp;

FinishCoursePopUp.propTypes = {
  certificateId: PropTypes.number.isRequired,
};
